var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-stub d-flex justify-center align-center"},[_c('app-spinner',{attrs:{"color":"primary","size":"xxl"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }